import React from "react";

function Profesionales() {
  return (
    <>
      <h1>En construcción</h1>
    </>
  );
}

export default Profesionales;
